import * as ol from 'openlayers';
import { Injectable } from '@angular/core';

@Injectable()
export class DraftingEvent {
  private _position = [];
  private _overlayArr = new Array();
  private _overlay: ol.Overlay = null;
  private _dragPan = null;
  private _moveFun = null;
  private _poinFun = null;
  constructor(private _map: ol.Map, private _callBack: Function) {
    // this.binDraftingEvent();
  }

  public serMarkerArr(overlay, id): void {
    const _this = this;
    _this._overlayArr[id] = overlay;
    _this._overlay = _this._overlayArr[id]._overlay;
    this._map.getInteractions().forEach(function (interaction) {
      if (interaction instanceof ol.interaction.DragPan) {
        _this._dragPan = interaction;
      }
    });
    _this._dragPan.setActive(false);
  }

  public binDraftingEvent(): void {
    const _this = this;
    _this._moveFun = function (evt) {
      if (_this._overlay) {
        if (_this._overlay.get('dragging') === true) {
          _this._overlay.setPosition(evt.coordinate);
          _this._position = evt.coordinate;
          if (_this._callBack) { _this._callBack.call(this, _this._position); }
        }
      }
      return false;
    };
    _this._poinFun = function (evt) {
      if (_this._overlay) {
        if (_this._overlay.get('dragging') === true) {
          _this._dragPan.setActive(true);
          _this._overlay.set('dragging', false);
        }
      }
      return false;
    };
    this._map.on('pointermove', _this._moveFun);
    this._map.on('pointerup', _this._poinFun);
  }

  public removDraftingEvent() {
    if (typeof this._moveFun === 'function' && typeof this._poinFun === 'function') {
      this._map.un('pointermove', this._moveFun);
      this._map.un('pointerup', this._poinFun);
    }
  }
}

@Injectable()
export abstract class Overlay {
  private _overlay: ol.Overlay;
  private _func;
  public _dragPan;
  private _fun;
  protected ele: HTMLElement = document.createElement('div');
  constructor() {
    this._overlay = new ol.Overlay({
      positioning: 'center-center',
      element: this.ele,
      stopEvent: false,
    });
    this.setHTMLElementStyle();
  }

  public setId(id: string): void {
    this.ele.id = id;
  }

  public setAttribute<T>(options: T): void {
    const data = JSON.stringify(options);
    this.ele.setAttribute('data-op', data);
  }

  public setOffset([x, y]: [number, number]): void {
    this._overlay.setOffset([x, y]);
  }

  public getAttribute<T>(): T {
    return JSON.parse(this.ele.dataset.op);
  }

  public setPosition([x, y]: [number, number]): void {
    this._overlay.setPosition([x, y]);
  }

  public getPosition(): Array<number> {
    return this._overlay.getPosition();
  }

  public getMarker(): ol.Overlay {
    return this._overlay;
  }

  public setText(text: string): void {
    this.ele.innerText = text;
  }

  public setHtml(html: any): void {
    this.ele.innerHTML = html;
  }

  public getId(): string {
    return this.ele.id;
  }

  public binEvent(event: string, fun): void {
    this._fun = fun;
    this.ele.addEventListener(event, this._fun, false);
  }

  public hover(fnOver, fnOut) {
    if (fnOver) {
      this.ele.addEventListener('mouseover', fnOver, false);
    }
    if (fnOut) {
      this.ele.addEventListener('mouseout', fnOut, false);
    }
  }

  public getDom(): HTMLElement {
    return this.ele;
  }

  public show(): void {
    this.ele.style.display = 'block';
  }

  public hide(): void {
    this.ele.style.display = 'none';
  }

  public startDrag(m: DraftingEvent):void {
    const _this = this;
    _this.ele.style.cursor = 'move';
    m.binDraftingEvent();
    _this._func = function () {
      m.serMarkerArr(_this, this.id);
      _this._overlay.set('dragging', true);
    };
    _this.binEvent('mousedown', _this._func);
  }

  public stopDrag(m: DraftingEvent): void {
    this.ele.style.cursor = 'default';
    this.ele.removeEventListener('mousedown', this._func);
    m.removDraftingEvent();
  }

  public removEvent(eventType: string):void {
    if (this._fun) { this.ele.removeEventListener(eventType, this._fun); }
  }

  abstract setHTMLElementStyle(): void;
}


export class LMarker extends Overlay {
  constructor(public imgSrc: string, public width: number = 16, private height: number = 16) {
    super();
    this.ele.style.position = 'relative';
    this.ele.style.cursor = 'pointer';
    this.ele.style.width = `${this.width}px`;
    this.ele.style.height = `${this.height}px`;
    this.ele.style.backgroundPosition = 'center center';
    this.ele.style.backgroundRepeat = 'no-repeat';
    this.ele.style.backgroundImage = `url(${this.imgSrc})`;
  }
  setHTMLElementStyle(): void {
  }
  public setImgSrc(src: string): void {
    this.ele.style.backgroundImage = `url(${src})`;
  }
}

export class CheckPoint extends Overlay {

  constructor(text: string, fontSize: number = 12) {
    super();
    this.ele.style.fontSize = 12 + 'px';
    this.ele.innerText = text;
    this.ele.style.position = 'relative';
    this.ele.style.width = '80px';
    this.ele.style.height = '15px';
    this.ele.style.borderRadius = '50%';
    this.ele.style.backgroundColor = 'transparent';
    this.ele.style.cursor = 'pointer';
    this.ele.style.lineHeight = '20px';
    this.ele.style.textAlign = 'center';
    this.ele.style.color = '#fff';
  }
  setHTMLElementStyle(): void { }
}

export class Label extends Overlay {
  constructor(text: string = '', public width: number = 126, public height: number = 26) {
    super();
    this.ele.style.width = `${width}px`;
    this.ele.style.height = `${height}px`;
    this.ele.style.backgroundColor = '#fff';
    this.ele.style.lineHeight = `${height}px`;
    this.ele.style.fontSize = '12px';
    this.ele.style.color = 'rgba(72, 84, 101, 1)';
    this.ele.style.borderRadius = '8px 14px 14px 0px';
    this.ele.style.padding = '0px 10px';
    this.ele.style.whiteSpace = 'nowrap';
    this.ele.style.zIndex = '999';
    this.ele.style.cursor = 'pointer';
    this.ele.style.marginLeft = '0';
    this.ele.style.marginRight = '0';
    this.setText(text);
  }
  setHTMLElementStyle(): void { }
}

// export class LableEr extends Overlay {
//   private _label = document.createElement('label');
//   private _div = document.createElement('div');
//   constructor(options: { amCode: string, amState: string, width?: number, height?: number }) {
//     super();
//     this.ele.style.backgroundColor = '#fff';
//     this.ele.style.borderRadius = '10px 16px 16px 0';
//     this.ele.style.fontSize = '12px';
//     this.ele.style.position = 'relative';
//     this.ele.style.paddingRight = '50px';
//     this.ele.style.paddingLeft = '11px';
//     this.ele.style.width = `${options.width || 127}px`;
//     this.ele.style.height = `${options.height || 26}px`;
//     this.ele.style.lineHeight = `${options.height}px`;
//     this._div.style.height = `${options.height || 26}px`;
//     this._div.style.lineHeight = `${options.height}px`;
//     this._div.style.color = '#485465';
//     this.ele.appendChild(this._label);
//     this._label.style.display = 'block';
//     this._label.style.width = `${50}px`;
//     this._label.style.height = `${options.height || 26}px`;
//     this._label.style.lineHeight = `${options.height}px`;
//     this._label.style.borderTopRightRadius = '16px';
//     this._label.style.borderBottomRightRadius = '16px';
//     this._label.style.backgroundColor = '#D3DBDE';
//     this._label.style.color = '#000';
//     this._label.style.position = 'absolute';
//     this._label.style.right = '0';
//     this._label.style.top = '0';
//     this._label.style.textAlign = 'center';
//     this.ele.appendChild(this._div);
//     this.setStaText(options.amCode, options.amState);
//   }

//   setHTMLElementStyle(): void { }

//   public setStaText(amCode: string = '', amState: string = ''): void {
//     this._div.innerText = amCode;
//     this._label.innerText = amState;
//   }

//   public setStateShowColor(backgroundColor: string, color: string): void {
//     if (backgroundColor) { this._label.style.backgroundColor = backgroundColor; }
//     if (color) { this._label.style.color = color; }
//   }
// }

export class LabelEr extends Overlay {
  private _ul: HTMLElement = document.createElement('ul');
  private _options: { nameArr: Array<string>, valArr: Array<string> };
  private _spans: Array<HTMLElement> = new Array();
  constructor(options: { nameArr: Array<string>, valArr: Array<string> }, public width: number = 235, public height: number = 73) {
    super();
    this._options = options;
    this.ele.style.boxSizing = 'border-box';
    this.ele.style.width = `${width}px`;
    this.ele.style.height = `${height}px`;
    this.ele.style.backgroundColor = '#fff';
    this.ele.style.fontSize = '12px';
    this.ele.style.borderRadius = '8px 14px 14px 0px';
    this.ele.style.padding = '8.5px 10px';
    this.ele.style.whiteSpace = 'nowrap';
    this.ele.style.marginLeft = '0';
    this.ele.style.marginRight = '0';
    this._init();
  }

  setHTMLElementStyle(): void {  }
  private _init(): void {
    const _parentNode = this.ele.parentElement;
    _parentNode.style.zIndex = '9999';
    this._ul.style.listStyle = 'none';
    this.ele.appendChild(this._ul);
    this._createLiAndLabelAndSapn();
  }

  private _createLiAndLabelAndSapn(): void {
    const nameArr = this._options.nameArr;
    const valArr = this._options.valArr;
    for (let i = 0; i < nameArr.length; i++) {
      const _li = document.createElement('li');
      const _label = document.createElement('label');
      const _span = document.createElement('span');
      this._spans.push(_span);
      _label.innerText = nameArr[i];
      _span.innerText = valArr[i];
      _li.appendChild(_label);
      _li.appendChild(_span);
      if (i !== 0) {
        _li.style.marginTop = '2px';
      }
      this._ul.appendChild(_li);
    }
  }

  public setValues(valArr: Array<string> = []): void {
    valArr.forEach((val: string, index: number) => this._spans[index].innerText = val);
  }

}

export class MenuPanel extends Overlay {
  private _isDisableArr: Array<boolean> = new Array();
  private _pArr: Array<HTMLElement> = new Array();
  constructor(
    private _nameArr: Array<string>,
    private _callback: Function,
    private width: number= 90, ) {
    super();
    this.ele.style.backgroundColor = '#fff';
    this.ele.style.borderRadius = '4px';
    this.ele.style.position = 'relative';
    this.ele.style.height = `${this._nameArr.length * 30}px`;
    this.ele.style.width = `${this.width}px`;
    this.ele.style.boxShadow = '0px 2px 4px 0px rgba(146, 158, 170, 1)';

    for (let i = 0; i < this._nameArr.length; i++) {
      this._isDisableArr[i] = true;
      this._pArr[i] = document.createElement('p');
      this._pArr[i].style.height = '30px';
      this._pArr[i].style.lineHeight = '30px';
      this._pArr[i].style.textAlign = 'center';
      this._pArr[i].style.color = 'rgba(72, 84, 101, 1)';
      this._pArr[i].style.fontSize = '14px';
      this._pArr[i].style.fontFamily = 'PingFangSC-Regular';
      this._pArr[i].style.cursor = 'pointer';
      this._pArr[i].setAttribute('key', i.toString());
      this.ele.appendChild(this._pArr[i]);
      if (i >= 1) {
        this._pArr[i].style.borderTop = '1px solid rgba(211, 219, 222, 1)';
      }
      this._pArr[i].innerText = this._nameArr[i];
      const _th = this;
      this._pArr[i].addEventListener('click', function (e) {
        const key = this.getAttribute('key');
        _th._callback(key);
        e.stopPropagation();
      });
    }
  }

  setHTMLElementStyle(): void { }

  public isDisables(arr: Array<boolean>): void {
    this._isDisableArr = arr;
    for (let i = 0; i < this._nameArr.length; i++) {
      if (!this._isDisableArr[i]) {
        this._pArr[i].style.color = 'rgba(146, 158, 170, 1)';
        this._pArr[i].style.cursor = 'default';
      } else {
        this._pArr[i].style.color = 'rgba(72, 84, 101, 1)';
        this._pArr[i].style.cursor = 'pointer';
      }
    }
  }
}

export function getFeatures(feature, map: ol.Map): any {
  const layers = map.getLayers().a;
  for (let i = 0; i < layers.length; i++) {
    const source = layers[i].getSource();
    if (source instanceof ol.source.Vector) {
      const features = source.getFeatures();
      if (features.length > 0) {
        for (let j = 0; j < features.length; j++) {
          if (features[j] === feature) {
            return layers[i];
          }
        }
      }
    }
  }
  return null;
}
